import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getVolumetricList = createAsyncThunk("/volumetric/getVolumetricList", async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
        const response = await axios.post(`${baseUrl}volumeMatrix/api/v1/getvolumeMatrixSearchList`, data, {
            headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        console.log("volumetric response", response);
        return response.data?.data;
    } catch (error) {
        console.error("Error fetching Volumetric List", error);

        // ✅ Handle errors properly
        return rejectWithValue(error.response?.data?.message || "Failed to fetch Volumetric List");
    }
});